/**
 * Эпик «TG welcome» W7 — превратить `chat_title` в кандидат для `project_name`.
 * Эвристика, ЗАПОЛНЯЕТ input в форме «Создать проект по имени чата»; admin
 * видит результат и правит руками ДО submit. Не автосабмит, не источник истины.
 *
 * Сепараторы (срез по ПЕРВОМУ): `|`, `/`, `:`, em-dash `—`, en-dash `–`.
 * ASCII hyphen `-` НЕ сепаратор — это уточнение к плану §1 (W7):
 *  «Coca-Cola — креатив» → «Coca-Cola» (рез по em-dash, сохранили дефис в бренде);
 *  «X-Press / Brief» → «X-Press»; «T-Mobile» → «T-Mobile»; «O-Zone : ТВ» → «O-Zone».
 *  Если бы `-` был сепаратором, Coca-Cola/X-Press/Y-Mobile ломались бы.
 *
 * Правила:
 *  - null / пустая строка → возвращаем как есть (`null` или `''`); UI отрисует пусто.
 *  - сепаратор есть → подстрока ДО первого сепаратора, trim;
 *    если результат пустой («| Workgroup») — fallback на весь title trim (не пустота).
 *  - сепаратора нет → весь title trim.
 *
 * Pure-функция, тестируется без браузера (apps/web/tests-e2e/parse-chat-title.spec.ts).
 */
const SEPARATOR_RE = /[|/:—–]/u // pipe, slash, colon, em-dash, en-dash (БЕЗ ASCII -)

export function parseChatTitle(chatTitle: string | null): string | null {
  if (chatTitle === null) return null
  const trimmed = chatTitle.trim()
  if (trimmed.length === 0) return ''

  const match = SEPARATOR_RE.exec(trimmed)
  if (!match) return trimmed // сепаратора нет → весь title

  const head = trimmed.slice(0, match.index).trim()
  return head.length > 0 ? head : trimmed // «| X» → fallback на весь title
}
